// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2MaOv","actions":"GroupTable_actions__23noh","deleteModalFooter":"GroupTable_deleteModalFooter__3hrzz"};